module.exports = __webpack_public_path__ + "img/show.f47b82d4.svg";